<template lang="pug">
.tag-view
  .tag(v-for="(tag, tagIndex) in tags" :key="tagIndex") {{ tag }}
</template>

<script>
export default {
  name: "TagView",
  props: {
    tags: {
      type: Array,
      default() {
        return [];
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-view{
  display: flex;
  margin-right: 8px;
  .tag{
    height: 24px;
    line-height: 24px;
    padding: 0 8px;
    border: 1px solid #FF5C00;
    border-radius: 4px;
    font-size: 12px;
    color: #FF5C00;
    box-sizing: border-box;
    & + .tag{
      margin-left: 8px;
    }
  }
}
</style>
